// import React, { useState } from 'react';
// import { Box, Button, Typography } from '@mui/material';
// import Papa from 'papaparse';
// import * as XLSX from 'xlsx';

// interface SpreadsheetUploadProps {
//   onUpload: (
//     sheetA: File | null,
//     sheetB: File | null,
//     columnsA: string[],
//     columnsB: string[],
//     dataA: any[][],
//     dataB: any[][]
//   ) => void;
// }

// const SpreadsheetUpload: React.FC<SpreadsheetUploadProps> = ({ onUpload }) => {
//   const [sheetA, setSheetA] = useState<File | null>(null);
//   const [sheetB, setSheetB] = useState<File | null>(null);
//   const [loading, setLoading] = useState(false);

//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, sheet: 'A' | 'B') => {
//     const file = e.target.files?.[0] || null;
//     if (sheet === 'A') setSheetA(file);
//     else setSheetB(file);
//   };

//   // Parsing CSV
//   const parseCSV = (file: File): Promise<any[][]> => {
//     return new Promise((resolve, reject) => {
//       Papa.parse(file, {
//         complete: (result: Papa.ParseResult<any>) => resolve(result.data as any[][]),  // Ensure it's cast to any[][]
//         error: (error: Papa.ParseError) => reject(error),  // Keep error handling
//       });
//     });
//   };

//   // Parsing XLSX
//   const parseXLSX = (file: File): Promise<any[][]> => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = (e: any) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const sheetName = workbook.SheetNames[0]; // Get the first sheet
//         const sheet = workbook.Sheets[sheetName];
//         const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 }) as any[][]; // Explicit cast here
//         resolve(sheetData);
//       };
//       reader.onerror = (error) => reject(error);
//       reader.readAsArrayBuffer(file);
//     });
//   };

//   // Handle form submission and parse files
//   const handleSubmit = async () => {
//     if (!sheetA || !sheetB) {
//       alert('Please upload both Sheet A and Sheet B.');
//       return;
//     }

//     setLoading(true);

//     try {
//       const formData = new FormData();
//       formData.append('sheetA', sheetA);
//       formData.append('sheetB', sheetB);

//       const res = await fetch('http://localhost:8080/api/columns', {
//         method: 'POST',
//         body: formData,
//       });

//       if (!res.ok) {
//         throw new Error('Failed to fetch columns and data');
//       }

//       // Initialize variables
//       let sheetAData: any[][] = [];
//       let sheetBData: any[][] = [];
//       let sheetAColumns: string[] = [];
//       let sheetBColumns: string[] = [];

//       // Determine the file type and parse accordingly
//       if (sheetA.name.endsWith('.csv')) {
//         sheetAData = await parseCSV(sheetA);
//         sheetAColumns = sheetAData[0] || [];
//         sheetAData = sheetAData.slice(1); // Exclude the header row
//       } else if (sheetA.name.endsWith('.xlsx')) {
//         sheetAData = await parseXLSX(sheetA);
//         sheetAColumns = sheetAData[0] || [];
//         sheetAData = sheetAData.slice(1); // Exclude the header row
//       }

//       if (sheetB.name.endsWith('.csv')) {
//         sheetBData = await parseCSV(sheetB);
//         sheetBColumns = sheetBData[0] || [];
//         sheetBData = sheetBData.slice(1); // Exclude the header row
//       } else if (sheetB.name.endsWith('.xlsx')) {
//         sheetBData = await parseXLSX(sheetB);
//         sheetBColumns = sheetBData[0] || [];
//         sheetBData = sheetBData.slice(1); // Exclude the header row
//       }

//       // Call onUpload with the parsed data
//       onUpload(sheetA, sheetB, sheetAColumns, sheetBColumns, sheetAData, sheetBData);
//     } catch (err) {
//       console.error('Error loading columns and data:', err);
//       alert('There was an error while loading the columns or data. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4 }}>
//       <Typography variant="h5" gutterBottom>
//         UPLOAD YOUR SPREADSHEETS
//       </Typography>

//       <input type="file" accept=".xlsx,.xls,.csv" onChange={(e) => handleFileChange(e, 'A')} />
//       <br />
//       <input type="file" accept=".xlsx,.xls,.csv" onChange={(e) => handleFileChange(e, 'B')} />
//       <br />
//       <Button variant="contained" onClick={handleSubmit} sx={{ mt: 2 }} disabled={loading}>
//         {loading ? 'Uploading...' : 'UPLOAD SHEETS'}
//       </Button>
//     </Box>
//   );
// };

// export default SpreadsheetUpload;

import React, { useState, useCallback } from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';

interface SpreadsheetUploadProps {
  onUpload: (
    sheetA: File | null,
    sheetB: File | null,
    columnsA: string[],
    columnsB: string[],
    dataA: any[][],
    dataB: any[][]
  ) => void;
}

const SpreadsheetUpload: React.FC<SpreadsheetUploadProps> = ({ onUpload }) => {
  const [sheetA, setSheetA] = useState<File | null>(null);
  const [sheetB, setSheetB] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const onDrop = useCallback((acceptedFiles: File[], sheet: 'A' | 'B') => {
    const file = acceptedFiles[0];
    if (!file) return;
    if (sheet === 'A') setSheetA(file);
    else setSheetB(file);
  }, []);

  const {
    getRootProps: getRootPropsA,
    getInputProps: getInputPropsA,
    isDragActive: isDragActiveA,
  } = useDropzone({
    onDrop: (files) => onDrop(files, 'A'),
    multiple: false,
    accept: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls'],
      'text/csv': ['.csv'],
    },
  });

  const {
    getRootProps: getRootPropsB,
    getInputProps: getInputPropsB,
    isDragActive: isDragActiveB,
  } = useDropzone({
    onDrop: (files) => onDrop(files, 'B'),
    multiple: false,
    accept: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls'],
      'text/csv': ['.csv'],
    },
  });

  const parseCSV = (file: File): Promise<any[][]> => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        complete: (result: Papa.ParseResult<any>) => resolve(result.data as any[][]),
        error: (error: Papa.ParseError) => reject(error),
      });      
    });
  };

  const parseXLSX = (file: File): Promise<any[][]> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 }) as any[][];
        resolve(sheetData);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  };

  const handleSubmit = async () => {
    if (!sheetA || !sheetB) {
      alert('Please upload both Sheet A and Sheet B.');
      return;
    }

    setLoading(true);

    try {
      let sheetAData: any[][] = [];
      let sheetBData: any[][] = [];
      let sheetAColumns: string[] = [];
      let sheetBColumns: string[] = [];

      if (sheetA.name.endsWith('.csv')) {
        sheetAData = await parseCSV(sheetA);
      } else {
        sheetAData = await parseXLSX(sheetA);
      }
      sheetAColumns = sheetAData[0] || [];
      sheetAData = sheetAData.slice(1);

      if (sheetB.name.endsWith('.csv')) {
        sheetBData = await parseCSV(sheetB);
      } else {
        sheetBData = await parseXLSX(sheetB);
      }
      sheetBColumns = sheetBData[0] || [];
      sheetBData = sheetBData.slice(1);

      onUpload(sheetA, sheetB, sheetAColumns, sheetBColumns, sheetAData, sheetBData);
    } catch (err) {
      console.error('Error loading columns and data:', err);
      alert('There was an error while loading the columns or data.');
    } finally {
      setLoading(false);
    }
  };

  const dropzoneStyle = {
    p: 2,
    border: '2px dashed #aaa',
    borderRadius: 2,
    textAlign: 'center',
    color: '#555',
    cursor: 'pointer',
    mb: 2,
    backgroundColor: '#fafafa',
  };

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        UPLOAD YOUR SPREADSHEETS
      </Typography>

      {/* Dropzone for Sheet A */}
      <Paper {...getRootPropsA()} sx={dropzoneStyle}>
        <input {...getInputPropsA()} />
        {isDragActiveA ? (
          <Typography>Drop the file for Sheet A here...</Typography>
        ) : sheetA ? (
          <Typography>Selected Sheet A: {sheetA.name}</Typography>
        ) : (
          <Typography>CLICK (or) DRAG [Sheet A] HERE</Typography>
        )}
      </Paper>

      {/* Dropzone for Sheet B */}
      <Paper {...getRootPropsB()} sx={dropzoneStyle}>
        <input {...getInputPropsB()} />
        {isDragActiveB ? (
          <Typography>Drop the file for Sheet B here...</Typography>
        ) : sheetB ? (
          <Typography>Selected Sheet B: {sheetB.name}</Typography>
        ) : (
          <Typography>CLICK (or) DRAG [Sheet B] HERE</Typography>
        )}
      </Paper>

      <Button variant="contained" onClick={handleSubmit} disabled={loading}>
        {loading ? 'Uploading...' : 'UPLOAD SHEETS'}
      </Button>
    </Box>
  );
};

export default SpreadsheetUpload;
